angular.module('unica.fields_directive', [])

.directive('fileExist',function() {
	return {
		require:'ngModel',
		link:function(scope, el, attrs, ngModel) {
			// change event is fired when file is selected
			el.bind('change',function(){
				scope.$apply(function(){
					ngModel.$setViewValue(el.val());
					ngModel.$render();
				});
			});
		}
	}
})

.directive('numbersOnly', function() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, modelCtrl) {
			modelCtrl.$parsers.push(function(inputValue) {
				if (inputValue == undefined) return ''
				var onlyNumeric = inputValue.replace(/[^0-9]/g, '');
				if (onlyNumeric != inputValue) {
					modelCtrl.$setViewValue(onlyNumeric);
					modelCtrl.$render();
				}
				return onlyNumeric;
			});
		}
	};
})

.directive('validFileExtensions', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModel) {
			var validFormats = ['jpg', 'jpeg', 'png'];
			elem.bind('change', function () {
				validImage(false);
				scope.$apply(function () {
					ngModel.$render();
				});
			});
			ngModel.$render = function () {
				ngModel.$setViewValue(elem.val());
			};
			function validImage(bool) {
				ngModel.$setValidity('extension', bool);
			}
			ngModel.$parsers.push(function(value) {
				var ext = value.substr(value.lastIndexOf('.')+1);
				if(ext=='') return;
				if(validFormats.indexOf(ext) == -1){
					return value;
				}
				validImage(true);
				return value;
			});
		}
	};
})

.directive('fileaws', function() { 
	return {
		restrict: 'AE',
		scope: {
			file: '@'
		},
		link: function(scope, el, attrs){
			el.bind('change', function(event){
				var files = event.target.files;
				var file = files[0];

				scope.fileAWS = file;
				scope.$parent.fileAWS = file;
				scope.$apply();
			});
		}
	};
})


.directive('ngThumb', ['$window', function($window,$scope) {
	var helper = {
		support: !!($window.FileReader && $window.CanvasRenderingContext2D),
		isFile: function(item) {
			return angular.isObject(item) && item instanceof $window.File;
		},
		isImage: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
		},
		isVideo: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|avi|mp4|mpeg|mov|quicktime|m4v|'.indexOf(type) !== -1;
		},
		isAudio: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|mp3|wav|ogg|'.indexOf(type) !== -1;
		},
		isPowerPoint: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|vnd.ms-powerpoint|vnd.openxmlformats-officedocument.presentationml.presentation|'.indexOf(type) !== -1;
		},
		isPDF: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|pdf|'.indexOf(type) !== -1;
		},
		isZip: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|zip|x-zip-compressed|'.indexOf(type) !== -1;
		},
		isWord: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|plain|rtf|msword|vnd.ms-word|vnd.openxmlformats-officedocument.wordprocessingml.document|'.indexOf(type) !== -1;
		},
		isExcel: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|msexcel|vnd.ms-excel|vnd.openxmlformats-officedocument.spreadsheetml.sheet|'.indexOf(type) !== -1;
		},
		isCSV: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|csv|'.indexOf(type) !== -1;
		},
		isMsg: function(file) {
			if ( file.type !== '' ) {
				var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			} else {
				var type = file.name.toLowerCase().substr(file.name.length - 3);
			}
			return '|msg|'.indexOf(type) !== -1;
		},
		isEml: function(file) {
			var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			return '|eml|rfc822|'.indexOf(type) !== -1;
		},
		isMxf: function(file) {
			if ( file.type !== '' ) {
				var type =  '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
			} else {
				var type = file.name.toLowerCase().substr(file.name.length - 3);
			}
			return '|mxf|'.indexOf(type) !== -1;
		},
	};

	return {
		restrict: 'A',
		template: '<canvas/>',
		link: function(scope, element, attributes) {

			if ( !helper.support ) {
				return;
			}

			var params = scope.$eval(attributes.ngThumb);

			if ( !helper.isFile(params.file) ) {
				return;
			}

			// console.log(params.file);

			if ( !helper.isImage(params.file)
				&& !helper.isVideo(params.file)
				&& !helper.isAudio(params.file)
				&& !helper.isPowerPoint(params.file)
				&& !helper.isPDF(params.file)
				&& !helper.isZip(params.file)
				&& !helper.isExcel(params.file)
				&& !helper.isCSV(params.file)
				&& !helper.isWord(params.file)
				&& !helper.isMsg(params.file)
				&& !helper.isEml(params.file)
				&& !helper.isMxf(params.file)
			) {
				var type =  params.file.type.slice(params.file.type.lastIndexOf('/') + 1);
				if ( !type ) {
					type = params.file.name.substr(params.file.name.length - 3);
				}

				scope.showErrorMsg('Not supported: ' + type);
				console.log('Not supported: ' + type);
				return;
			}

			var canvas = element.find('canvas');

			if ( helper.isWord(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/doc-default.png';
			}
			else if ( helper.isExcel(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/xls-default.png';
			}
			else if ( helper.isCSV(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/csv-default.png';
			}
			else if ( helper.isZip(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/zip-default.png';
			}
			else if ( helper.isPowerPoint(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/ppt-default.png';
			}
			else if ( helper.isPDF(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/pdf-default.png';
			}
			else if ( helper.isAudio(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/audio-default.png';
			}
			else if ( helper.isMsg(params.file) || helper.isEml(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/email-default.png';
			}
			else if ( helper.isMxf(params.file) )
			{
				var img = new Image();
				img.onload = onLoadImage;
				img.src = '/img/video-default.png';
			}
			else if ( params.file.size > 5000000)
			{
				var img = new Image();
				img.onload = onLoadImage;
				if ( helper.isImage(params.file) ) {
					img.src = '/img/image-default.png';
				} else { 
					img.src = '/img/video-default.png';
				}
			}
			else
			{
				var reader = new FileReader();
				reader.onload = onLoadFile;
				reader.readAsDataURL( params.file );
			}

			function onLoadFile(event) {
				if ( helper.isImage(params.file) ) {
					var img = new Image();
					img.onload = onLoadImage;
					img.src = event.target.result;
				}else if ( helper.isVideo(params.file) ) {
					var video = document.createElement("video"),
						source = document.createElement("source");

					source.src = event.target.result;
					video.appendChild(source);
					video.setAttribute("src", event.target.result);
					video.onloadeddata = function(e) {
						loadThumbVideo(video, e);
					};
				}
			}

			function onLoadImage() {
				var width = params.width || this.width / this.height * params.height;
				var height = params.height || this.height / this.width * params.width;
				//canvas for preview upload
				canvas.attr({ width: width, height: height });
				canvas[0].getContext('2d').drawImage(this, 0, 0, width, height);

				//canvas for archive thumb file 
				if ( scope.mediaData && scope.mediaData.files && scope.mediaData.files.length > 0 ) {

					var canvasBig = document.createElement("canvas"),
						canvasBigW = this.width,
						canvasBigH = this.height;

					if ( Math.max( this.width, this.height ) > (params.width * 10) ) {
						var coef = Math.floor( Math.max( this.width, this.height ) / (params.width * 10) );
						canvasBigW = Math.round(canvasBigW / coef * 100) / 100 ;
						canvasBigH = Math.round(canvasBigH / coef * 100) / 100 ;
					}

					canvasBig.setAttribute('width', canvasBigW);
					canvasBig.setAttribute('height', canvasBigH);
					canvasBig.getContext('2d').drawImage(this, 0, 0, canvasBigW, canvasBigH);

					scope.mediaData.files[params.pos]['thumb'] =  canvasBig.toDataURL("image/png").replace("image/png", "image/octet-stream");
					scope.mediaData.files[params.pos]['isReady'] = true;
					scope.$apply();

				}
			}


			function loadThumbVideo(obj, e) {
				var width  = params.width,
					height = params.height;

				// canvas for preview upload
				canvas.attr({ width: width, height: height });
				canvas[0].getContext('2d').drawImage(obj, 0, 0, width, height);

				//canvas for archive thumb file
				if ( scope.mediaData && scope.mediaData.files && scope.mediaData.files.length > 0 ) {
					var canvasBig = document.createElement("canvas"),
						canvasBigW = 400,
						canvasBigH = 400;

					if ( e.path.length > 0 ) {
						canvasBigW = e.path[0].videoWidth;
						canvasBigH = e.path[0].videoHeight;
						if ( Math.max( canvasBigW, canvasBigH ) > (params.width * 4) ) {
							var coef = Math.floor( Math.max( canvasBigW, canvasBigH ) / (params.width * 4) );
							canvasBigW = Math.round(canvasBigW / coef * 100) / 100 ;
							canvasBigH = Math.round(canvasBigH / coef * 100) / 100 ;
						}
					}

					canvasBig.setAttribute('width', canvasBigW);
					canvasBig.setAttribute('height', canvasBigH);
					canvasBig.getContext('2d').drawImage(obj, 0, 0, canvasBigW, canvasBigH);

					scope.mediaData.files[params.pos]['thumb'] =  canvasBig.toDataURL("image/png").replace("image/png", "image/octet-stream");
					scope.mediaData.files[params.pos]['isReady'] = true;
					scope.$apply();

				}
			}

		}

	};

}]);
